import React, { useEffect, useMemo, useState } from "react";
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { isEmpty } from "lodash";
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";
import  moment from "moment";

//import components
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import DeleteModal from '../../../components/Common/DeleteModal';
import 'react-dropzone-uploader/dist/styles.css'
import Dropzone from 'react-dropzone-uploader';

import {
  deleteOrder as onDeleteOrder,
} from "store/actions";

import {
  addNewWorkshop2 as onAdddNewWorkshop2,
  getWorkShop2 as onGetWorkShop2,
  updateWorkshop2 as onUpdateWorkshop2,
  deleteWorkshop2 as onDeleteWorkshop2,

} from "store/contacts/actions";

import {
  Title,
  Date,
  Status,
}
  from "./EcommerceOrderCol";

//redux
import { useSelector, useDispatch } from "react-redux";
import EcommerceOrdersModal from "./EcommerceOrdersModal";
import LangModal from '../../../components/Common/LangModal';

import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
} from "reactstrap";
import axios from "axios";

function EcommerceOrder() {

  //meta title
  document.title = "Ürün Alt Kategori | Buhara - Admin Paneli";

  const [modal, setModal] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [langModal, setLangModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const [orderList, setOrderList] = useState([]);
  const [order, setOrder] = useState(null);
  const [getWorkShopEdit, setWorkShopEdit] = useState(null);
  const [getCategory, setCategory] = useState([]);
  const [getCategoryID, setCategoryID] = useState(null);
  const [getIsActive, setIsActive] = useState(false);

  const [getFileNameBanner, setFileNameBanner] = useState(null);


  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      ID: (getWorkShopEdit && getWorkShopEdit.ID) || '',

      title: (getWorkShopEdit && getWorkShopEdit.Products_SubCategory_Name) || '',
   

    },
    validationSchema: Yup.object({
      title: Yup.string().required("Başlığı Giriniz"),
    }),
    onSubmit: (values) => {
      if (isEdit) {
        const updateWorkshop = {
          ID: order ? order.ID : 0,
          Products_SubCategory_Name: values.title,
          Products_Category_ID:getCategoryID,
          Products_SubCategory_Image : getFileNameBanner,
          IsActive : getIsActive

         // Products_Category_ID : 

          //	Products_SubCategory_Name:
            //	Products_SubCategory_Image:
            //  	Products_SubCategory_EngName:
                  //  Workshop_StartDate: values.orderdate,
        //   Workshop_FinishDate: values.startDate,
        };
        // update order
        dispatch(onUpdateWorkshop2(updateWorkshop));
        validation.resetForm();
      } else {
        const newOrder = {
          Products_SubCategory_Name: values["title"],
          Products_Category_ID:getCategoryID,
          Products_SubCategory_Image : getFileNameBanner,
          IsActive : getIsActive

        };
        // save new order
        dispatch(onAdddNewWorkshop2(newOrder));
        validation.resetForm();
      }
      toggle();
    },
  });


  const toggleViewModal = () => setModal1(!modal1);

  const dispatch = useDispatch();
  const { orders } = useSelector(state => ({
    orders: state.contacts.workshop2,
  }));

  useEffect(() => {
    if (orders && !orders.length) {
      dispatch(onGetWorkShop2());
      setIsEdit(false);
    }
  }, [dispatch, orders]);

  useEffect(() => {
    setOrderList(orders);
  }, [orders]);

  useEffect(() => {
    if (!isEmpty(orders) && !!isEdit) {
      setOrderList(orders);
      setIsEdit(false);
    }
  }, [orders]);

  const toggle = () => {
    if (modal) {
      setModal(false);
      setOrder(null);
    } else {
      setModal(true);
    }
  };

  const _getAuthData = async () => {

    await axios.get(`https://buharaapi.stechomeyazilim.info/Products_Category`)
      .then((res) => {
        console.log("skldf",res.data.value || res.data)
        setCategory(res.data.value || res.data)
      })
  }

  useEffect(() => {
    _getAuthData()

  }, []);

  const handleOrderClick = arg => {
    const order = arg;
    setWorkShopEdit(order)
    setOrder(order);

    setIsEdit(true);
    setIsActive(order.IsActive)
    setCategoryID(order.Products_Category_ID)
    setFileNameBanner(order.Products_SubCategory_Image)
    toggle()
  };

  //delete order
  const [deleteModal, setDeleteModal] = useState(false);



  const Preview = ({ meta }) => {
    const { name, percent, status, previewUrl } = meta;
    return (
      <div className="preview-box">
        <img src={previewUrl} /> <span className="name">{name}</span> - <span className="status">{status == "done" ? "Başarıyla Yüklendi" : "Yükleniyor"}</span>{status !== "done" && <span className="percent"> ({Math.round(percent)}%)</span>}
      </div>
    )
  }

  const getUploadParams = ({ file }) => {
    const body = new FormData();
    body.append('dataFile', file);
    return { url: 'https://buharaadmin.stechomeyazilim.info:8099/uploadfile', body }
  }
   
  // handle the status of the file upload
  const handleChangeStatusBanner = ({ xhr }) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const result = JSON.parse(xhr.response);
          setFileNameBanner(result.file.filename)

        }
      }
    }
  }

  const onClickDelete = (order) => {
    setOrder(order);
    setDeleteModal(true);
  };

  const handleDeleteOrder = () => {
    if (order && order.ID) {
      dispatch(onDeleteWorkshop2(order.ID));
      setDeleteModal(false);
    }
  };
  const handleOrderClicks = () => {
    setOrderList("");
    setIsEdit(false);
    toggle();
  };

  const _setChoiceCategory = arg => {
    setCategoryID(arg.target.value)
  }

  const columns = useMemo(
    () => [
      {
        Header: 'ID',
        accessor: 'ID',
        disableFilters: true,
        filterable: true,
        Cell: (cellProps) => {
          return <Title {...cellProps} />;
        }
      },

      {
        Header: "Görsel",
        // accessor: "name",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps) => (
          <>
            {!cellProps.Products_SubCategory_Image ? (
              <div className="avatar-xl">
               {cellProps.Products_SubCategory_Name != null ? <span className="avatar-title rounded-circle">
                  {cellProps.Products_SubCategory_Name.charAt(0)}
                </span> : null}
              </div>
            ) : (
              <div>
                <img
                  className=" avatar-xl"
                  src={'https://buharasubdomain.stechomeyazilim.info/' +  cellProps.Products_SubCategory_Image}
                  alt=""
                />
              </div>
            )}
          </>
        ),
      },

      {
        Header: 'Başlık',
        accessor: 'Products_SubCategory_Name',
        disableFilters: true,
        filterable: true,
        Cell: (cellProps) => {
          return <Title {...cellProps} />;
        }
      },
   
   
      {
        Header: 'Kategori Adı',
        accessor: 'Products_Category.Products_Category_Name',
        filterable: true,
        disableFilters: true,
        Cell: (cellProps) => {
          return <Title {...cellProps} />;
        }
      },
      
  
      {
        Header: 'Aktiflik Durumu',
        accessor: 'IsActive',
        filterable: true,
        disableFilters: true,
        Cell: (cellProps) => {
          return <Status {...cellProps} />;
        }
      },
    /* {
        Header: 'Detaylar',
        accessor: 'view',
        disableFilters: true,
        Cell: () => {
          return (
            <Button
              type="button"
              color="primary"
              className="btn-sm btn-rounded"
              onClick={toggleViewModal}
            >
              Detayları füntüle
            </Button>);
        }
      },*/
      {
        Header: 'İşlemler',
        accessor: 'action',
        disableFilters: true,
        Cell: (cellProps) => {
          return (
            <div className="d-flex gap-3">
              <Link
                to="#"
                className="text-success"
                onClick={() => {
                  const orderData = cellProps.row.original;
                  handleOrderClick(orderData);
                }}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Düzenle
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-info"
                onClick={() => {
                  setSelectedItem(cellProps.row.original);
                  setLangModal(true);
                }}
              >
                <i className="mdi mdi-translate font-size-18" id="langtooltip-subcat" />
                <UncontrolledTooltip placement="top" target="langtooltip-subcat">
                  Çeviriler
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  const orderData = cellProps.row.original;
                  onClickDelete(orderData);
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Sil
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        }
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <EcommerceOrdersModal isOpen={modal1} toggle={toggleViewModal} />
      <LangModal
        isOpen={langModal}
        toggle={() => setLangModal(false)}
        title="Alt Kategori"
        tableName="Products_SubCategory_Lang"
        foreignKey="SubCategory_ID"
        foreignKeyValue={selectedItem?.ID}
        fields={[
          { name: 'Products_SubCategory_Name', label: 'Alt Kategori Adı', type: 'text' },
        ]}
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteOrder}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Buhara" breadcrumbItem="AltKategori" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={orders}
                    isGlobalFilter={true}
                    isAddWorkshop2={true}
                    handleOrderClicks={handleOrderClicks}
                    customPageSize={10}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit ? "Alt Kategori Düzenle" : "Alt Kategori Ekle"}
            </ModalHeader>
            <ModalBody>
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <Row>
                  <Col className="col-12">

              
                  
                    <div className="mb-3">
                      <Label className="form-label">Başlık</Label>
                      <Input
                        name="title"
                        type="text"
                        placeholder="Başlık"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.title || ""}
                        invalid={
                          validation.touched.title && validation.errors.title ? true : false
                        }
                      />
                      {validation.touched.title && validation.errors.title ? (
                        <FormFeedback type="invalid">{validation.errors.title}</FormFeedback>
                      ) : null}
                    </div>
                  
                  
                    <div className="mb-3">
                              <Label className="form-label">Kategori Seçiniz</Label>
                              <Input
                                name="paymentStatus"
                                type="select"
                                className="form-select"
                                defaultValue={getCategoryID}
                                onChange={(text) => _setChoiceCategory(text)}
                                value={
                                  getCategoryID
                                }>
       <option value="">Lütfen Seçim Yapınız</option>

                                {getCategory.map((item, index) => (
                                  <option value={item.ID} key={item.ID}>{item.Products_Category_Name}</option>
                                ))}

                              </Input>
                              {validation.touched.wsText && validation.errors.wsText ? (
                                <FormFeedback type="invalid">{validation.errors.wsText}</FormFeedback>
                              ) : null}
                            </div>

                            <div className="d-flex">
                  <label htmlFor="resume">Aktiflik Durumu</label>

                          <div className="square-switch">
                            <input
                              type="checkbox"
                              id="square-switch"
                              className="switch"
                              defaultChecked={getIsActive}
                              onChange={() =>
                                setIsActive(!getIsActive)
                              }
                            />
                            <label
                         htmlFor="square-switch"
                              data-on-label="Aktif "
                              data-off-label="Pasif"
                            />
                          </div>
                        
                       
                        </div>


                        <Row>
                <Col xs={12} className="mb-3">
                            <label htmlFor="resume">Görsel</label>
                         <Dropzone
          getUploadParams={getUploadParams}
          onChangeStatus={handleChangeStatusBanner}
          maxFiles={1}
          styles={{
            dropzone: { overflow: 'auto', border: '1px solid #999', background: '#f5f5f5' },
            inputLabelWithFiles: { margin: '20px 3%' }
          }}
          canRemove={false}
          PreviewComponent={Preview}
          accept="image/*"
        />
                
                          </Col>
                </Row>


                {getFileNameBanner != null ?   <Row>
                <label htmlFor="resume">Eklenen Resim</label>

                <Col xs={12} className="mb-3">
                            <img
                  className=" avatar-xl"
                  src={'https://buharasubdomain.stechomeyazilim.info/' +  getFileNameBanner}
                  alt=""
                />
                          </Col>
                </Row> : null}

                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="text-end">
                      <button
                        type="submit"
                        className="btn btn-success save-user"
                      >
                        KAYDET
                      </button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>
        </div>
      </div>
    </React.Fragment>
  );
}
EcommerceOrder.propTypes = {
  preGlobalFilteredRows: PropTypes.any,

};


export default EcommerceOrder;